module.exports = __webpack_public_path__ + "img/south.67fc2ca9.jpg";